export const WEEKLY_PROFESSOR_QUIZ_SUBJECT_ID =
  "960e37de-5054-444a-8763-897a07178b2f";

export const HANDELS_GESELLSCHAFTSRECHT_SUBJECT_ID =
  "d2c5857d-4d6c-4e1d-aaa5-a6a0875cac40";

export const TECHNISCHE_MECHANIK_1_SUBJECT_ID =
  "385999b9-532a-4526-8ba4-40c86f47a0f2";

export const GRUNDLAGEN_ELEKTROTECHNIK_2_SUBJECT_ID =
  "94ce3248-7a00-40be-b5f6-8c4f831ad526";

export const KLAUSUR_PRAXIS_SUBJECT_IDS = [
  WEEKLY_PROFESSOR_QUIZ_SUBJECT_ID,
  HANDELS_GESELLSCHAFTSRECHT_SUBJECT_ID,
];

export const SIMILAR_AUFGABEN_SUBJECT_IDS = [
  TECHNISCHE_MECHANIK_1_SUBJECT_ID,
  GRUNDLAGEN_ELEKTROTECHNIK_2_SUBJECT_ID,
];

export const TASKS_FIRST_WHEN_AVAILABLE_SUBJECT_IDS = [
  TECHNISCHE_MECHANIK_1_SUBJECT_ID,
  GRUNDLAGEN_ELEKTROTECHNIK_2_SUBJECT_ID,
];

export const DIRECT_ALTKLAUSUREN_PRACTICE_SUBJECT_IDS = [
  TECHNISCHE_MECHANIK_1_SUBJECT_ID,
  GRUNDLAGEN_ELEKTROTECHNIK_2_SUBJECT_ID,
];

export const WEEKLY_PROFESSOR_QUIZ_ALTKLAUSUR_ID =
  "789f14b6-fada-4f61-a708-774cd7736795";

export const WEEKLY_PROFESSOR_QUIZ_LABEL =
  "Wöchentliche Quizfragen (vom Professor)";

export const WEEKLY_PROFESSOR_LAST_LECTURE_QUESTION_ID =
  "36578a48-24d3-4a40-90cf-d5a483a1985f";

export const WEEKLY_PROFESSOR_CURRENT_LECTURE_QUESTION_ID =
  "1c1ec925-51bd-4315-95b8-b80385b67dfb";

export const WEEKLY_PROFESSOR_QUIZ_SLOTS = [
  {
    id: "current",
    questionId: WEEKLY_PROFESSOR_CURRENT_LECTURE_QUESTION_ID,
    title: "Quiz zur aktuellen Vorlesung",
    tutorTitle: "Quizfrage für diese Woche",
    subtitle: "Aktuelle Vorlesung",
    badge: "Diese Woche",
  },
  {
    id: "previous",
    questionId: WEEKLY_PROFESSOR_LAST_LECTURE_QUESTION_ID,
    title: "Wiederholungsquiz",
    tutorTitle: "Quizfrage für letzte Woche",
    subtitle: "Vorherige Vorlesung",
    badge: "Wiederholung",
  },
];

export const isWeeklyProfessorQuizSubject = (subjectId) =>
  String(subjectId || "").toLowerCase() === WEEKLY_PROFESSOR_QUIZ_SUBJECT_ID;

export const isKlausurPraxisSubject = (subjectId) => {
  const normalized = String(subjectId || "").toLowerCase();
  return KLAUSUR_PRAXIS_SUBJECT_IDS.includes(normalized);
};

export const isSimilarAufgabenSubject = (subjectId) => {
  const normalized = String(subjectId || "").toLowerCase();
  return SIMILAR_AUFGABEN_SUBJECT_IDS.includes(normalized);
};

export const isDirectAltklausurenPracticeSubject = (subjectId) => {
  const normalized = String(subjectId || "").toLowerCase();
  return DIRECT_ALTKLAUSUREN_PRACTICE_SUBJECT_IDS.includes(normalized);
};

export const getDirectAltklausurenPracticeLabel = (subjectId) => {
  const normalized = String(subjectId || "").toLowerCase();

  if (normalized === GRUNDLAGEN_ELEKTROTECHNIK_2_SUBJECT_ID) {
    return "Klausur Praxis";
  }

  if (normalized === TECHNISCHE_MECHANIK_1_SUBJECT_ID) {
    return "Altklausuren und Praxis";
  }

  return "Praxis-Modus";
};

export const getAltKlausurenPracticeLabel = (subjectId) =>
  isWeeklyProfessorQuizSubject(subjectId)
    ? WEEKLY_PROFESSOR_QUIZ_LABEL
    : isDirectAltklausurenPracticeSubject(subjectId)
    ? getDirectAltklausurenPracticeLabel(subjectId)
    : "Alt Klausuren";

export const getWeeklyProfessorQuizSlot = (questionId) =>
  WEEKLY_PROFESSOR_QUIZ_SLOTS.find((slot) => slot.questionId === questionId) ||
  null;

export const orderWeeklyProfessorQuestions = (questions = []) =>
  WEEKLY_PROFESSOR_QUIZ_SLOTS.map((slot) => ({
    slot,
    question: questions.find((question) => question?.id === slot.questionId) || null,
  }));

export const isTasksFirstWhenAvailableSubject = (subjectId) => {
  const normalized = String(subjectId || "").toLowerCase();
  return TASKS_FIRST_WHEN_AVAILABLE_SUBJECT_IDS.includes(normalized);
};

export const getLessonPracticeDefaultTab = (subjectId, taskCount = 0) => {
  if (isTasksFirstWhenAvailableSubject(subjectId)) {
    return Number(taskCount || 0) > 0 ? "aufgaben" : "quiz";
  }

  return isKlausurPraxisSubject(subjectId) ? "quiz" : "aufgaben";
};
